import { TemplateConfig } from '../types';

export const workplaceBottleneckSpreadConfig: TemplateConfig = {
  id: 'workplace-bottleneck-spread',
  name: '职场卡点牌阵',
  description: '分析职场瓶颈原因与突破方向',
  cardCount: 8,
  
  fieldDefaults: {
    title: '职场卡点牌阵',
    customerQuestion: '分析我目前处于职场瓶颈期的原因，以及之后应该怎样做才能突破职场瓶颈。',
    cardPlaceholders: [
      '请输入第 2 列第 1 张牌',
      '请输入第 1 列第 1 张牌',
      '请输入第 2 列第 2 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 2 列第 3 张牌',
      '请输入第 1 列第 2 张牌',
      '请输入第 3 列第 2 张牌',
      '请输入第 3 列第 3 张牌'
    ],
    cardInfos: [
      '当前卡点。你现在真正的瓶颈出在哪里？例如：是能力？心态？关系？还是环境？——明确卡住的核心点。',
      '隐藏风险。有哪些你忽略了的“职场暗礁”？例如：谁在默默下绊子？哪些信号正在积压为危机？',
      '职场印象。你在上司/同事眼中的真实定位？别人给你打的标签是怎样的？',
      '人际突破口。有没有可联动的关系，可以成为晋升/调岗/资源突破的关键人？',
      '晋升潜力评估。你近期有没有“实打实”的晋升可能？看机会有无、是否靠谱、该争还是该退？',
      '行动建议。下一阶段，你应该采取什么实际行为？比如主动提案 / 调整汇报风格 / 找项目机会等。',
      '软实力升级。哪一项软能力，是你晋升或破局的关键杠杆？例如：情绪管理？表达能力？部门协调？',
      '三个月事业走势预测。如果你按建议调整，3个月内局面可能会有什么改变？'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#0958d9',
    backgroundColor: '#e6f4ff',
    icon: '🧭'
  }
};
